<template>
  <!-- POC Cuidados Paliativos: mensagem de boas-vindas ao enviar o paciente
       para casa. Usado na aba Gestão e no quadro do Ambulatório. -->
  <div class="home-welcome">
    <lila-textarea
      v-model="message"
      label="Mensagem de boas-vindas"
    />
    <p class="hw-hint">
      O link para baixar o app vai por SMS. Esta mensagem aparece para o paciente quando ele abrir o app.
      Você pode ajustar o texto ou só confirmar.
    </p>
    <p class="hw-sms-chip">
      Link do app Lila enviado por SMS
    </p>

    <div class="hw-actions">
      <lila-button
        type="button"
        title="Confirmar"
        :second-button="{ type: 'button', title: 'Cancelar' }"
        @custom-click-event="$emit('confirm', message.trim() || defaultMessage)"
        @custom-click-cancel-event="$emit('cancel')"
      />
    </div>
  </div>
</template>

<script>
import Button from "@components/shared/button/Button.vue";
import Textarea from "@components/shared/fields/Textarea.vue";
import { defaultWelcomeMessage } from "@/services/palliative/carePlanApi";

export default {
  name: "HomeWelcomeComposer",
  components: {
    "lila-button": Button,
    "lila-textarea": Textarea
  },
  props: {
    patientName: {
      type: String,
      default: ""
    }
  },
  emits: ["confirm", "cancel"],
  data() {
    return {
      message: defaultWelcomeMessage(this.patientName)
    };
  },
  computed: {
    defaultMessage() {
      return defaultWelcomeMessage(this.patientName);
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #4f3f82;
$muted: #6b6b7b;

.home-welcome {
  text-align: left;

  :deep(.field) {
    margin-bottom: 0;
  }

  :deep(.textarea-component .label) {
    margin-left: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #484848;
  }

  :deep(textarea) {
    min-height: 140px;
  }
}

.hw-hint {
  margin: 8px 0 0 20px;
  font-size: 12px;
  line-height: 16px;
  color: $muted;
}

.hw-sms-chip {
  display: inline-block;
  margin: 10px 0 0 20px;
  padding: 3px 10px;
  border: 1px dashed $primary;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: $primary;
}

.hw-actions {
  margin-top: 20px;
}
</style>
